import { render } from "./DestinationDetailView.vue?vue&type=template&id=dea5d4c2"
import script from "./DestinationDetailView.vue?vue&type=script&lang=js"
export * from "./DestinationDetailView.vue?vue&type=script&lang=js"

import exportComponent from "/home/adrian/Proyectos/eunoia_travel/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__